import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import './Onboarding.scss'
import React from 'react'
import { getUserOnboardingData, updateOnboardingStatus } from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import { getAllUserDetails, fetchAsyncUserDetails } from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { ROLES } from '../../../Utils/Constant/roles'

const FinishPage: FC = () => {
  const onboarding = useSelector(getUserOnboardingData);
  const userDetails = useSelector(getAllUserDetails);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const steps = [
    'Reviewing your Information....',
    'Configuring your Cellcast account....',
    'Personalising your account....',
  ];

  const getRedirectUrl = () => {
    const isOwner = userDetails?.role === ROLES.OWNER;

    if (!isOwner) {
      return '/dashboard';
    }

    return '/new-message';
  };

  useEffect(() => {
    if (!onboarding.isComplete) return;

    if (step < steps.length) {
      const timer = setTimeout(() => setStep(step + 1), 2000);
      return () => clearTimeout(timer);
    } else {
      const redirectTimer = setTimeout(async () => {
        dispatch(updateOnboardingStatus(true));
        await dispatch(fetchAsyncUserDetails());
        const redirectUrl = getRedirectUrl();
        navigate(redirectUrl);
      }, 4000);
      return () => clearTimeout(redirectTimer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, onboarding.isComplete]);

  return (
    <div className='onboarding'>
      {onboarding.isComplete ? (
        <>
          <div className='d-flex flex-column align-items-center justify-content-center h-100'>
            <div className='mb-10 ms-5 margincls text-center'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/onboarding/onboarding-process.gif')}
                style={{height: '300px', width: '500px'}}
              />
            </div>
            <div className='d-flex flex-column'>
              <h2 className='lh-base mb-2 fw-boldest onboarding-first-title mb-10 display-6'>
                Thank you we are getting your account ready
              </h2>
              <div className='d-flex flex-column gap-3'>
                {steps.slice(0, step).map((text, idx) => (
                  <div className='d-flex align-items-center gap-2 mb-10'>
                    <img
                      alt='check'
                      src={toAbsoluteUrl('/media/icons/duotune/art/check-circle.svg')}
                    />
                    <p key={idx} className='fw-normal onboarding-description-finish mb-0'>
                      {text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default React.memo(FinishPage)
